import React from 'react';

import * as d from 'date-fns';

import { type CSSProperties, styles } from '../../../style';
import { BudgetSummaryChart } from '../../budget/report/budgetsummary/BudgetSummaryChart';
import { Block } from '../../common/Block';
import { Link } from '../../common/Link';
import { View } from '../../common/View';
import { DateRange } from '../DateRange';
import { ReportCard } from '../ReportCard';

type BudgetSummaryCardProps = {
  showViewAll?: boolean;
  cardStyles?: CSSProperties;
};

export function BudgetSummaryCard({
  showViewAll,
  cardStyles = {},
}: BudgetSummaryCardProps) {
  const startDate = d.startOfMonth(new Date()).toISOString();
  const endDate = d.endOfMonth(new Date()).toISOString();
  return (
    <View id="budget-summary-report-card">
      <ReportCard
        flex={1}
        style={{ height: 'fit-Content', ...cardStyles }}
        {...(!showViewAll ? { to: '/reports/budget-summary' } : {})}
      >
        <View style={{ padding: 20 }}>
          <View
            style={{
              flex: 1,
              flexDirection: 'row',
              justifyContent: 'space-between',
              alignItems: 'center',
            }}
          >
            <Block
              style={{ ...styles.mediumText, fontWeight: 500, marginBottom: 5 }}
              role="heading"
            >
              Budget vs Actual
            </Block>
            {showViewAll && (
              <Link to="/budget" variant="internal">
                View more
              </Link>
            )}
          </View>
          <DateRange start={startDate} end={endDate}/>
        </View>
        <BudgetSummaryChart />
      </ReportCard>
    </View>
  );
}
